<script>
import Plugin from '../index';

const { notify } = useFlashNotification();
const { web3Account } = useWeb3();

const STATES = {
  NOT_VOTED: {
    headerImage: 'https://snapshotsplugin.s3.us-west-2.amazonaws.com/vote.svg',
    header: 'poap.no_voted_header',
    buttonText: 'poap.button_claim'
  },
  UNCLAIMED: {
    headerImage: 'https://snapshotsplugin.s3.us-west-2.amazonaws.com/claim.svg',
    header: 'poap.unclaimed_header',
    buttonText: 'poap.button_claim'
  },
  CLAIMED: {
    headerImage:
      'https://snapshotsplugin.s3.us-west-2.amazonaws.com/succes.svg',
    header: 'poap.claimed_header',
    buttonText: 'poap.button_show'
  },
  LOADING: {
    headerImage:
      'https://snapshotsplugin.s3.us-west-2.amazonaws.com/succes.svg',
    header: 'poap.loading_header',
    buttonText: ''
  }
};

// STATES
const NO_POAP = 'NO_POAP';
const NOT_VOTED = 'NOT_VOTED';
const LOADING = 'LOADING';
const UNCLAIMED = 'UNCLAIMED';
const CLAIMED = 'CLAIMED';

export default {
  props: ['space', 'proposal', 'results', 'loaded', 'strategies'],
  data() {
    return {
      loading: false,
      plugin: new Plugin(),
      currentState: LOADING,
      address: '',
      poapImg: '',
      loadButton: false
    };
  },
  computed: {
    web3Account() {
      return web3Account.value;
    },
    header() {
      return STATES[this.currentState].header;
    },
    buttonText() {
      return STATES[this.currentState].buttonText;
    },
    mainImg() {
      return this.poapImg ? this.poapImg : STATES[this.currentState].mainImage;
    },
    headerImg() {
      return STATES[this.currentState].headerImage;
    },
    actionEnabled() {
      return this.currentState !== NOT_VOTED && this.currentState !== NO_POAP;
    },
    actionLoading() {
      return this.currentState === LOADING || this.loadButton;
    }
  },
  watch: {
    currentState: async function (newCurrentState) {
      if (newCurrentState === LOADING) {
        // If the state is loading: start updating the state
        this.checkStateLoop(this.updateState);
      }
    },
    web3Account: async function (newAccount) {
      // Update the state if the address
      this.loading = true;
      this.address = newAccount;
      await this.updateState();
      this.loading = false;
    }
  },
  async created() {
    this.address = web3Account.value;
    this.loading = true;
    await this.updateState();
  },
  methods: {
    async action() {
      switch (this.currentState) {
        case CLAIMED:
          this.plugin.openScanPage(this.address);
          break;
        case UNCLAIMED:
          this.loadButton = true;
          this.currentState = await this.plugin.claim(
            this.proposal.id,
            this.address
          );
          this.loadButton = false;
          break;
      }
    },
    // Check the state if the current state is loading
    async checkStateLoop() {
      await this.updateState();
      switch (this.currentState) {
        case LOADING:
          setTimeout(() => this.checkStateLoop(), 5000);
          break;
        case UNCLAIMED:
          notify(['red', this.$t('poap.error_claim')]);
          break;
        case CLAIMED:
          notify(['green', this.$t('poap.success_claim')]);
      }
    },
    async updateState() {
      const response = await this.plugin.getCurrentState(
        this.proposal.id,
        this.address
      );

      const { currentState, image_url } = response;

      if (image_url) {
        this.poapImg = image_url;
      }

      this.currentState = currentState;
      this.loading = false;
    }
  }
};
</script>

<template>
  <TuneBlock
    v-if="currentState === 'LOADING' || currentState !== 'NO_POAP'"
    :loading="loading"
  >
    <div class="flex flex-col items-center">
      <img :src="headerImg" alt="" class="mb-2" />
      <div class="mb-2 text-center text-skin-link">{{ $t(header) }}</div>
      <img
        :src="mainImg"
        alt=""
        class="mt-1"
        style="
          vertical-align: middle;
          width: auto;
          height: auto;
          max-width: 125px;
        "
      />
      <TuneButton
        v-if="currentState !== 'NO_POAP'"
        class="mt-3 w-full"
        :disabled="!actionEnabled"
        :loading="actionLoading"
        @click="action"
      >
        {{ $t(buttonText) }}
      </TuneButton>
    </div>
  </TuneBlock>
</template>
